import styled from 'styled-components';
import { Column } from 'hedron';

/* Disable ESlint rule for this file */
/* eslint react/destructuring-assignment: "off" */

const FlexColumn = styled(Column)`
    display:flex;
    justify-content: ${props => props.justify};
    align-items: ${props => props.align};
`;

export default FlexColumn;


// WEBPACK FOOTER //
// ./src/blocks/FlexColumn/FlexColumn.jsx